import EditButtonStyle from './EditButton.styles';
import EditIcon from '@/assets/images/edit.svg?component';
import type { MouseEventHandler } from 'react';

type EditButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const EditButton = ({ onClick }: EditButtonProps) => (
  <EditButtonStyle type="button" onClick={onClick}>
    <EditIcon/>
  </EditButtonStyle>
);
